import { render, staticRenderFns } from "./SimpleSearchBar.vue?vue&type=template&id=0299b1cc"
import script from "./SimpleSearchBar.vue?vue&type=script&lang=js"
export * from "./SimpleSearchBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports